import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar/Sidebar";
import Navbar from "../Navbar/Navbar";
import { axiosConfig } from "../axiosAPI";
import { useAuth } from "../AuthProvider";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { Form } from "react-bootstrap";
import Swal from "sweetalert2";
import "../Assets/Css/Table.css";

function CityRidesPrice() {
  const [cityRidesData, setCityRidesData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editDialogVisible, setEditDialogVisible] = useState(false);
  const [baseFareEditDialogVisible, setBaseFareEditDialogVisible] = useState(false);
  const [kmRateDialogVisible, setKmRateDialogVisible] = useState(false);
  const [editFormData, setEditFormData] = useState({
    baseFare: 0,
    kmRates: [],
    dogFeeRates: []
  });
  const [newBaseFare, setNewBaseFare] = useState(0);
  const [newKmRate, setNewKmRate] = useState({ minKm: 0, maxKm: 0, pricePerKm: 0 });
  const [editingKmRate, setEditingKmRate] = useState(null);
  const [isEditingKmRate, setIsEditingKmRate] = useState(false);
  const [newDogFeeRate, setNewDogFeeRate] = useState({ minKm: 0, maxKm: 0, pricePerKm: 0 });
  const [editingDogFeeRate, setEditingDogFeeRate] = useState(null);
  const [isEditingDogFeeRate, setIsEditingDogFeeRate] = useState(false);
  const [dogFeeRateDialogVisible, setDogFeeRateDialogVisible] = useState(false);
  const auth = useAuth();

  const fetchCityRidesData = async () => {
    try {
      setLoading(true);
      const response = await axiosConfig.get(
        `${process.env.REACT_APP_BASE_URL}/pricing/city-rides`,
        {
          headers: {
            Authorization: "Bearer " + auth.token,
            "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
          },
        }
      );
      setCityRidesData(response.data.data);
      setEditFormData({
        baseFare: response.data.data.baseFare || 0,
        kmRates: response.data.data.kmRates || [],
        dogFeeRates: response.data.data.dogFeeRates || []
      });
    } catch (error) {
      console.error("Error fetching city rides data:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Failed to fetch city rides pricing data!",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCityRidesData();
  }, []);

  const handleEdit = () => {
    setNewBaseFare(cityRidesData.baseFare || 0);
    setBaseFareEditDialogVisible(true);
  };

  const handleUpdateBaseFare = async () => {
    try {
      const response = await axiosConfig.put(
        `${process.env.REACT_APP_BASE_URL}/pricing/city-rides/base-fare`,
        {
          baseFare: newBaseFare
        },
        {
          headers: {
            Authorization: "Bearer " + auth.token,
            "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
          },
        }
      );
      
      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Base fare updated successfully!",
        });
        setBaseFareEditDialogVisible(false);
        fetchCityRidesData();
      }
    } catch (error) {
      console.error("Error updating base fare:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Failed to update base fare!",
      });
    }
  };

  const handleAddKmRate = async () => {
    try {
      const response = await axiosConfig.post(
        `${process.env.REACT_APP_BASE_URL}/pricing/city-rides/km-rates`,
        newKmRate,
        {
          headers: {
            Authorization: "Bearer " + auth.token,
            "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
          },
        }
      );
      
      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Kilometer rate added successfully!",
        });
        setKmRateDialogVisible(false);
        setNewKmRate({ minKm: 0, maxKm: 0, pricePerKm: 0 });
        fetchCityRidesData();
      }
    } catch (error) {
      console.error("Error adding kilometer rate:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Failed to add kilometer rate!",
      });
    }
  };

  const handleEditKmRate = (rate) => {
    setEditingKmRate(rate);
    setNewKmRate({ ...rate });
    setIsEditingKmRate(true);
    setKmRateDialogVisible(true);
  };

  const handleUpdateKmRate = async () => {
    try {
      const response = await axiosConfig.post(
        `${process.env.REACT_APP_BASE_URL}/pricing/city-rides/km-rates/${editingKmRate.uuid}`,
        newKmRate,
        {
          headers: {
            Authorization: "Bearer " + auth.token,
            "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
          },
        }
      );
      
      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Kilometer rate updated successfully!",
        });
        setKmRateDialogVisible(false);
        setEditingKmRate(null);
        setIsEditingKmRate(false);
        setNewKmRate({ minKm: 0, maxKm: 0, pricePerKm: 0 });
        fetchCityRidesData();
      }
    } catch (error) {
      console.error("Error updating kilometer rate:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Failed to update kilometer rate!",
      });
    }
  };

  const handleDeleteKmRate = async (uuid) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      });

      if (result.isConfirmed) {
        const response = await axiosConfig.delete(
          `${process.env.REACT_APP_BASE_URL}/pricing/city-rides/km-rates/${uuid}`,
          {
            headers: {
              Authorization: "Bearer " + auth.token,
              "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
            },
          }
        );
        
        if (response.data.success) {
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: "Kilometer rate has been deleted.",
          });
          fetchCityRidesData();
        }
      }
    } catch (error) {
      console.error("Error deleting kilometer rate:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Failed to delete kilometer rate!",
      });
    }
  };

  const handleAddDogFeeRate = async () => {
    try {
      const response = await axiosConfig.post(
        `${process.env.REACT_APP_BASE_URL}/pricing/city-rides/dog-fee-rates`,
        newDogFeeRate,
        {
          headers: {
            Authorization: "Bearer " + auth.token,
            "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
          },
        }
      );
      
      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Dog fee rate added successfully!",
        });
        setDogFeeRateDialogVisible(false);
        setNewDogFeeRate({ minKm: 0, maxKm: 0, pricePerKm: 0 });
        fetchCityRidesData();
      }
    } catch (error) {
      console.error("Error adding dog fee rate:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Failed to add dog fee rate!",
      });
    }
  };

  const handleEditDogFeeRate = (rate) => {
    setEditingDogFeeRate(rate);
    setNewDogFeeRate({ ...rate });
    setIsEditingDogFeeRate(true);
    setDogFeeRateDialogVisible(true);
  };

  const handleUpdateDogFeeRate = async () => {
    try {
      const response = await axiosConfig.post(
        `${process.env.REACT_APP_BASE_URL}/pricing/city-rides/dog-fee-rates/${editingDogFeeRate.uuid}`,
        newDogFeeRate,
        {
          headers: {
            Authorization: "Bearer " + auth.token,
            "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
          },
        }
      );
      
      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Dog fee rate updated successfully!",
        });
        setDogFeeRateDialogVisible(false);
        setEditingDogFeeRate(null);
        setIsEditingDogFeeRate(false);
        setNewDogFeeRate({ minKm: 0, maxKm: 0, pricePerKm: 0 });
        fetchCityRidesData();
      }
    } catch (error) {
      console.error("Error updating dog fee rate:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Failed to update dog fee rate!",
      });
    }
  };

  const handleDeleteDogFeeRate = async (uuid) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      });

      if (result.isConfirmed) {
        const response = await axiosConfig.delete(
          `${process.env.REACT_APP_BASE_URL}/pricing/city-rides/dog-fee-rates/${uuid}`,
          {
            headers: {
              Authorization: "Bearer " + auth.token,
              "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
            },
          }
        );
        
        if (response.data.success) {
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: "Dog fee rate has been deleted.",
          });
          fetchCityRidesData();
        }
      }
    } catch (error) {
      console.error("Error deleting dog fee rate:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Failed to delete dog fee rate!",
      });
    }
  };

  const handleSave = async () => {
    try {
      const response = await axiosConfig.put(
        `${process.env.REACT_APP_BASE_URL}/pricing/city-rides`,
        editFormData,
        {
          headers: {
            Authorization: "Bearer " + auth.token,
            "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
          },
        }
      );
      
      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "City rides pricing updated successfully!",
        });
        setEditDialogVisible(false);
        fetchCityRidesData(); // Refresh data
      }
    } catch (error) {
      console.error("Error updating city rides data:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Failed to update city rides pricing!",
      });
    }
  };

  const addKmRate = () => {
    setEditFormData(prev => ({
      ...prev,
      kmRates: [...prev.kmRates, { minKm: 0, maxKm: 0, pricePerKm: 0 }]
    }));
  };

  const removeKmRate = (index) => {
    setEditFormData(prev => ({
      ...prev,
      kmRates: prev.kmRates.filter((_, i) => i !== index)
    }));
  };

  const updateKmRate = (index, field, value) => {
    setEditFormData(prev => ({
      ...prev,
      kmRates: prev.kmRates.map((rate, i) => 
        i === index ? { ...rate, [field]: value } : rate
      )
    }));
  };

  const addDogFeeRate = () => {
    setEditFormData(prev => ({
      ...prev,
      dogFeeRates: [...prev.dogFeeRates, { minKm: 0, maxKm: 0, pricePerKm: 0 }]
    }));
  };

  const removeDogFeeRate = (index) => {
    setEditFormData(prev => ({
      ...prev,
      dogFeeRates: prev.dogFeeRates.filter((_, i) => i !== index)
    }));
  };

  const updateDogFeeRate = (index, field, value) => {
    setEditFormData(prev => ({
      ...prev,
      dogFeeRates: prev.dogFeeRates.map((rate, i) => 
        i === index ? { ...rate, [field]: value } : rate
      )
    }));
  };

  if (loading) {
    return (
      <div className="main">
        <div className="sidebar">
          <Sidebar />
        </div>
        <div className="dev-table">
          <Navbar />
          <div className="table-card">
            <div className="table">
              <div className="text-center p-4">
                <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
                <p>Loading city rides pricing data...</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="main">
        <div className="sidebar">
          <Sidebar />
        </div>
        <div className="dev-table">
          <Navbar />
          <div className="table-card">
            <div className="table">
              {/* Base Fare Card */}
              <div className="row mb-4">
                <div className="col-12">
                  <Card 
                    title="Base Fare Configuration" 
                    className="h-100"
                  >
                    <div className="row align-items-center">
                      <div className="col-md-6">
                        <div className="text-center">
                          <h2 className="text-primary mb-0">EGP {cityRidesData?.baseFare || 0}</h2>
                          <p className="text-muted">Base fare for city rides</p>
                        </div>
                      </div>
                      <div className="col-md-6 text-end">
                        <Button 
                          label="Edit" 
                          icon="pi pi-pencil" 
                          className="p-button-primary"
                          onClick={handleEdit}
                        />
                      </div>
                    </div>
                  </Card>
                </div>
              </div>

              {/* KM Rates Table */}
              <div className="row mb-4">
                <div className="col-12">
                  <Card 
                    title="Kilometer Rates" 
                    className="h-100"
                  >
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5 className="mb-0">Rates Configuration</h5>
                      <Button 
                        label="Add Rate" 
                        icon="pi pi-plus" 
                        size="small"
                        onClick={() => {
                          setNewKmRate({ minKm: 0, maxKm: 0, pricePerKm: 0 });
                          setKmRateDialogVisible(true);
                        }}
                      />
                    </div>
                    {cityRidesData?.kmRates && cityRidesData.kmRates.length > 0 ? (
                      <DataTable 
                        value={cityRidesData.kmRates} 
                        showGridlines 
                        stripedRows
                        size="small"
                        className="p-datatable-sm"
                      >
                        <Column 
                          field="minKm" 
                          header="Min KM" 
                          style={{ width: '20%' }}
                          body={(rowData) => `${rowData.minKm} km`}
                        />
                        <Column 
                          field="maxKm" 
                          header="Max KM" 
                          style={{ width: '20%' }}
                          body={(rowData) => `${rowData.maxKm} km`}
                        />
                        <Column 
                          field="pricePerKm" 
                          header="Price/KM" 
                          style={{ width: '20%' }}
                          body={(rowData) => `EGP ${rowData.pricePerKm}`}
                        />
                        <Column 
                          header="Range" 
                          style={{ width: '20%' }}
                          body={(rowData) => `${rowData.minKm} - ${rowData.maxKm} km`}
                        />
                        <Column 
                          header="Actions" 
                          style={{ width: '20%' }}
                          body={(rowData) => (
                            <div className="d-flex gap-1">
                              <Button 
                                icon="pi pi-pencil" 
                                className="p-button-sm p-button-primary"
                                onClick={() => handleEditKmRate(rowData)}
                              />
                              <Button 
                                icon="pi pi-trash" 
                                className="p-button-sm p-button-danger"
                                onClick={() => handleDeleteKmRate(rowData.uuid)}
                              />
                            </div>
                          )}
                        />
                      </DataTable>
                    ) : (
                      <div className="text-center p-3">
                        <p className="text-muted">No kilometer rates configured</p>
                      </div>
                    )}
                  </Card>
                </div>
              </div>

              {/* Dog Fee Rates Table */}
              <div className="row mb-4">
                <div className="col-12">
                  <Card 
                    title="Dog Fee Rates" 
                    className="h-100"
                  >
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5 className="mb-0">Rates Configuration</h5>
                      <Button 
                        label="Add Rate" 
                        icon="pi pi-plus" 
                        size="small"
                        onClick={() => {
                          setNewDogFeeRate({ minKm: 0, maxKm: 0, pricePerKm: 0 });
                          setDogFeeRateDialogVisible(true);
                        }}
                      />
                    </div>
                    {cityRidesData?.dogFeeRates && cityRidesData.dogFeeRates.length > 0 ? (
                      <DataTable 
                        value={cityRidesData.dogFeeRates} 
                        showGridlines 
                        stripedRows
                        size="small"
                        className="p-datatable-sm"
                      >
                        <Column 
                          field="minKm" 
                          header="Min KM" 
                          style={{ width: '20%' }}
                          body={(rowData) => `${rowData.minKm} km`}
                        />
                        <Column 
                          field="maxKm" 
                          header="Max KM" 
                          style={{ width: '20%' }}
                          body={(rowData) => `${rowData.maxKm} km`}
                        />
                        <Column 
                          field="pricePerKm" 
                          header="Price/KM" 
                          style={{ width: '20%' }}
                          body={(rowData) => `EGP ${rowData.pricePerKm}`}
                        />
                        <Column 
                          header="Range" 
                          style={{ width: '20%' }}
                          body={(rowData) => `${rowData.minKm} - ${rowData.maxKm} km`}
                        />
                        <Column 
                          header="Actions" 
                          style={{ width: '20%' }}
                          body={(rowData) => (
                            <div className="d-flex gap-1">
                              <Button 
                                icon="pi pi-pencil" 
                                className="p-button-sm p-button-primary"
                                onClick={() => handleEditDogFeeRate(rowData)}
                              />
                              <Button 
                                icon="pi pi-trash" 
                                className="p-button-sm p-button-danger"
                                onClick={() => handleDeleteDogFeeRate(rowData.uuid)}
                              />
                            </div>
                          )}
                        />
                      </DataTable>
                    ) : (
                      <div className="text-center p-3">
                        <p className="text-muted">No dog fee rates configured</p>
                      </div>
                    )}
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Base Fare Edit Dialog */}
      <Dialog 
        visible={baseFareEditDialogVisible} 
        modal 
        header="Edit Base Fare" 
        style={{ width: '35rem' }}
        className="p-dialog-md"
        onHide={() => setBaseFareEditDialogVisible(false)}
        footer={
          <div className="d-flex justify-content-end gap-2">
            <Button 
              label="Cancel" 
              icon="pi pi-times" 
              onClick={() => setBaseFareEditDialogVisible(false)} 
              className="p-button-outlined p-button-secondary" 
            />
            <Button 
              label="Update Base Fare" 
              icon="pi pi-check" 
              onClick={handleUpdateBaseFare} 
              className="p-button-primary"
              autoFocus 
            />
          </div>
        }
      >
        <div className="p-4">
          <div className="row">
            <div className="col-12">
              <Form.Group>
                <Form.Label className="fw-bold text-dark mb-3">
                  <i className="pi pi-dollar me-2"></i>
                  Base Fare Amount
                </Form.Label>
                <InputNumber
                  value={newBaseFare}
                  onValueChange={(e) => setNewBaseFare(e.value || 0)}
                  mode="currency"
                  currency="EGP"
                  locale="en-US"
                  className="w-100"
                  placeholder="Enter base fare amount"
                  min={0}
                />
                <small className="text-muted mt-2 d-block">
                  This is the base fare that will be charged for all city rides
                </small>
              </Form.Group>
            </div>
          </div>
        </div>
      </Dialog>

      {/* KM Rate Dialog */}
      <Dialog 
        visible={kmRateDialogVisible} 
        modal 
        header={isEditingKmRate ? "Edit Kilometer Rate" : "Add Kilometer Rate"} 
        style={{ width: '50rem' }}
        className="p-dialog-lg"
        onHide={() => {
          setKmRateDialogVisible(false);
          setEditingKmRate(null);
          setIsEditingKmRate(false);
          setNewKmRate({ minKm: 0, maxKm: 0, pricePerKm: 0 });
        }}
        footer={
          <div className="d-flex justify-content-end gap-2">
            <Button label="Cancel" icon="pi pi-times" onClick={() => {
              setKmRateDialogVisible(false);
              setEditingKmRate(null);
              setIsEditingKmRate(false);
              setNewKmRate({ minKm: 0, maxKm: 0, pricePerKm: 0 });
            }} className="p-button-outlined p-button-secondary" />
            <Button 
              label={isEditingKmRate ? "Update Rate" : "Add Rate"} 
              icon="pi pi-check" 
              onClick={isEditingKmRate ? handleUpdateKmRate : handleAddKmRate} 
              className="p-button-primary"
              autoFocus 
            />
          </div>
        }
      >
        <div className="p-4">
          <div className="row g-3">
            <div className="col-md-6">
              <Form.Group>
                <Form.Label className="fw-bold text-dark mb-2">
                  <i className="pi pi-map-marker me-2"></i>
                  Min KM
                </Form.Label>
                <InputNumber
                  value={newKmRate.minKm}
                  onValueChange={(e) => setNewKmRate(prev => ({ ...prev, minKm: e.value || 0 }))}
                  className="w-100"
                  placeholder="Enter minimum KM"
                  min={0}
                />
              </Form.Group>
            </div>
            <div className="col-md-6">
              <Form.Group>
                <Form.Label className="fw-bold text-dark mb-2">
                  <i className="pi pi-map-marker me-2"></i>
                  Max KM
                </Form.Label>
                <InputNumber
                  value={newKmRate.maxKm}
                  onValueChange={(e) => setNewKmRate(prev => ({ ...prev, maxKm: e.value || 0 }))}
                  className="w-100"
                  placeholder="Enter maximum KM"
                  min={0}
                />
              </Form.Group>
            </div>
            <div className="col-md-12">
              <Form.Group>
                <Form.Label className="fw-bold text-dark mb-2">
                  <i className="pi pi-dollar me-2"></i>
                  Price/KM (EGP)
                </Form.Label>
                <InputNumber
                  value={newKmRate.pricePerKm}
                  onValueChange={(e) => setNewKmRate(prev => ({ ...prev, pricePerKm: e.value || 0 }))}
                  mode="currency"
                  currency="EGP"
                  locale="en-US"
                  className="w-100"
                  placeholder="Enter price per KM"
                  min={0}
                />
              </Form.Group>
            </div>
          </div>
        </div>
      </Dialog>

      {/* Dog Fee Rate Dialog */}
      <Dialog 
        visible={dogFeeRateDialogVisible} 
        modal 
        header={isEditingDogFeeRate ? "Edit Dog Fee Rate" : "Add Dog Fee Rate"} 
        style={{ width: '50rem' }}
        className="p-dialog-lg"
        onHide={() => {
          setDogFeeRateDialogVisible(false);
          setEditingDogFeeRate(null);
          setIsEditingDogFeeRate(false);
          setNewDogFeeRate({ minKm: 0, maxKm: 0, pricePerKm: 0 });
        }}
        footer={
          <div className="d-flex justify-content-end gap-2">
            <Button label="Cancel" icon="pi pi-times" onClick={() => {
              setDogFeeRateDialogVisible(false);
              setEditingDogFeeRate(null);
              setIsEditingDogFeeRate(false);
              setNewDogFeeRate({ minKm: 0, maxKm: 0, pricePerKm: 0 });
            }} className="p-button-outlined p-button-secondary" />
            <Button 
              label={isEditingDogFeeRate ? "Update Rate" : "Add Rate"} 
              icon="pi pi-check" 
              onClick={isEditingDogFeeRate ? handleUpdateDogFeeRate : handleAddDogFeeRate} 
              className="p-button-primary"
              autoFocus 
            />
          </div>
        }
      >
        <div className="p-4">
          <div className="row g-3">
            <div className="col-md-6">
              <Form.Group>
                <Form.Label className="fw-bold text-dark mb-2">
                  <i className="pi pi-map-marker me-2"></i>
                  Min KM
                </Form.Label>
                <InputNumber
                  value={newDogFeeRate.minKm}
                  onValueChange={(e) => setNewDogFeeRate(prev => ({ ...prev, minKm: e.value || 0 }))}
                  className="w-100"
                  placeholder="Enter minimum KM"
                  min={0}
                />
              </Form.Group>
            </div>
            <div className="col-md-6">
              <Form.Group>
                <Form.Label className="fw-bold text-dark mb-2">
                  <i className="pi pi-map-marker me-2"></i>
                  Max KM
                </Form.Label>
                <InputNumber
                  value={newDogFeeRate.maxKm}
                  onValueChange={(e) => setNewDogFeeRate(prev => ({ ...prev, maxKm: e.value || 0 }))}
                  className="w-100"
                  placeholder="Enter maximum KM"
                  min={0}
                />
              </Form.Group>
            </div>
            <div className="col-md-12">
              <Form.Group>
                <Form.Label className="fw-bold text-dark mb-2">
                  <i className="pi pi-dollar me-2"></i>
                  Price/KM (EGP)
                </Form.Label>
                <InputNumber
                  value={newDogFeeRate.pricePerKm}
                  onValueChange={(e) => setNewDogFeeRate(prev => ({ ...prev, pricePerKm: e.value || 0 }))}
                  mode="currency"
                  currency="EGP"
                  locale="en-US"
                  className="w-100"
                  placeholder="Enter price per KM"
                  min={0}
                />
              </Form.Group>
            </div>
          </div>
        </div>
      </Dialog>

      {/* Edit Dialog */}
      <Dialog 
        visible={editDialogVisible} 
        modal 
        header="Edit City Rides Pricing" 
        style={{ width: '80rem' }}
        onHide={() => setEditDialogVisible(false)}
        footer={
          <div>
            <Button label="Cancel" icon="pi pi-times" onClick={() => setEditDialogVisible(false)} className="p-button-text" />
            <Button label="Save" icon="pi pi-check" onClick={handleSave} autoFocus />
          </div>
        }
      >
        <div className="row">
          {/* Base Fare */}
          <div className="col-12 mb-4">
            <Form.Group>
              <Form.Label><strong>Base Fare (EGP)</strong></Form.Label>
              <InputNumber
                value={editFormData.baseFare}
                onValueChange={(e) => setEditFormData(prev => ({ ...prev, baseFare: e.value || 0 }))}
                mode="currency"
                currency="EGP"
                locale="en-US"
                className="w-100"
              />
            </Form.Group>
          </div>

          {/* KM Rates */}
          <div className="col-md-6 mb-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5>Kilometer Rates</h5>
              <Button 
                label="Add Rate" 
                icon="pi pi-plus" 
                size="small"
                onClick={addKmRate}
              />
            </div>
            {editFormData.kmRates.map((rate, index) => (
              <div key={index} className="border rounded p-3 mb-2">
                <div className="row">
                  <div className="col-4">
                    <Form.Group>
                      <Form.Label>Min KM</Form.Label>
                      <InputNumber
                        value={rate.minKm}
                        onValueChange={(e) => updateKmRate(index, 'minKm', e.value || 0)}
                        className="w-100"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-4">
                    <Form.Group>
                      <Form.Label>Max KM</Form.Label>
                      <InputNumber
                        value={rate.maxKm}
                        onValueChange={(e) => updateKmRate(index, 'maxKm', e.value || 0)}
                        className="w-100"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-3">
                    <Form.Group>
                      <Form.Label>Price/KM</Form.Label>
                      <InputNumber
                        value={rate.pricePerKm}
                        onValueChange={(e) => updateKmRate(index, 'pricePerKm', e.value || 0)}
                        mode="currency"
                        currency="EGP"
                        locale="en-US"
                        className="w-100"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-1 d-flex align-items-end">
                    <Button 
                      icon="pi pi-trash" 
                      className="p-button-danger p-button-sm"
                      onClick={() => removeKmRate(index)}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Dog Fee Rates */}
          <div className="col-md-6 mb-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5>Dog Fee Rates</h5>
              <Button 
                label="Add Rate" 
                icon="pi pi-plus" 
                size="small"
                onClick={addDogFeeRate}
              />
            </div>
            {editFormData.dogFeeRates.map((rate, index) => (
              <div key={index} className="border rounded p-3 mb-2">
                <div className="row">
                  <div className="col-4">
                    <Form.Group>
                      <Form.Label>Min KM</Form.Label>
                      <InputNumber
                        value={rate.minKm}
                        onValueChange={(e) => updateDogFeeRate(index, 'minKm', e.value || 0)}
                        className="w-100"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-4">
                    <Form.Group>
                      <Form.Label>Max KM</Form.Label>
                      <InputNumber
                        value={rate.maxKm}
                        onValueChange={(e) => updateDogFeeRate(index, 'maxKm', e.value || 0)}
                        className="w-100"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-3">
                    <Form.Group>
                      <Form.Label>Price/KM</Form.Label>
                      <InputNumber
                        value={rate.pricePerKm}
                        onValueChange={(e) => updateDogFeeRate(index, 'pricePerKm', e.value || 0)}
                        mode="currency"
                        currency="EGP"
                        locale="en-US"
                        className="w-100"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-1 d-flex align-items-end">
                    <Button 
                      icon="pi pi-trash" 
                      className="p-button-danger p-button-sm"
                      onClick={() => removeDogFeeRate(index)}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Dialog>
    </>
  );
}

export default CityRidesPrice;
